export default __webpack_public_path__ + "static/travel-hero-jetty-3866aff9f9c48271d8e03ffcf63dfbb1.png";